<template>
  <v-form>
    <v-row dense>
      <v-col cols="12">
        <span style="font-size: 16px; font-weight: bold">{{record.Name}}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="7">
        <v-text-field name="managePriceListSearch" dense outlined label="Search" v-model="search"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="7">
        <v-data-table :mobile-breakpoint="zeroValue" :items-per-page="pageItems" :headers="headers" :items="itm4" :search="search">
          <!-- action template -->
          <template v-slot:item.action="{ item }">
            <v-btn color="editIcon" icon @click="openModal(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <!-- end -->
        </v-data-table>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  name: "PriceListIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
    priceList: {
      type: String
    }
  },
  data: () => ({
    search: "",
    zeroValue: 0,
    pageItems: 100,
    excelFile: null,
    dialog: false,
    editItem: {},
    loader: false,
    record: {},
    itm4: [],
    headers: [
      { text: "Product", value: "product.Name" },
      { text: "Selling Price", value: "SellingPrice" }
    ],
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.itm4 = val.itm4;
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    openModal(data) {
      this.editItem = data;
      this.dialog = true;
    },
    sendData() {
      const data = new FormData();
      data.append("productsData", this.excelFile);
      data.append("o_p_l_n_s_id", this.record.id);
      this.loader = true;
      this.$emit("data", data);
    },
    save() {
      const id = this.editItem.id;
      const url = `/products-price-list/${id}`;
      const data = {
        SellingPrice: this.editItem.SellingPrice,
        LowerLimit: this.editItem.LowerLimit
      };
      this.loader = true;
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>